import React, { FC, KeyboardEvent } from 'react';
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Link from 'components/commercetools-ui/atoms/link';
import Typography from 'components/commercetools-ui/atoms/typography';
import useClassNames from 'helpers/hooks/useClassNames';
import { Category } from 'types/entity/category';

export interface Props {
  link: Category;
  categoriesNavigator?: Category[];
  onClick: () => void;
  hideHeaderMenu: () => void;
}

const MobileMenuNavButton: FC<Props> = ({ link, categoriesNavigator, onClick, hideHeaderMenu }) => {
  const linkClassNames = useClassNames([
    'flex justify-between',
    categoriesNavigator?.length === 0 ? '' : link?.categoryId === 'myAccount' ? 'pt-32' : '',
  ]);

  const handleKeyDown = (e: KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      link?.descendants && link.descendants.length > 0 ? onClick() : hideHeaderMenu();
    }
  };
  return (
    <li key={link.categoryId} className="cursor-pointer list-none">
      {link?.descendants && link?.descendants?.length > 0 ? (
        <button
          onClick={onClick}
          onKeyDown={handleKeyDown}
          className="flex w-full appearance-none justify-between border-0 bg-transparent"
          tabIndex={0}
        >
          <Typography className="text-primary text-start">{link.name}</Typography>
          <ChevronRightIcon className="w-20 text-icon-secondary" />
        </button>
      ) : (
        <div onClick={hideHeaderMenu} className={linkClassNames}>
          <Link link={link?._url ?? link?.slug}>
            <Typography className="text-primary">{link.name}</Typography>
          </Link>
        </div>
      )}
    </li>
  );
};

export default MobileMenuNavButton;
